export default __webpack_public_path__ + "static/media/SanctumOfTheBurningSouls.ad3858af.jpg";